import { Check } from "lucide-react";

import { t } from "../i18n/i18n";
import { useUi } from "../state/ui";
import { unsavedDrafts, useLeaveRequest } from "../state/unsavedDrafts";
import { ConfirmDialog } from "./ConfirmDialog";
import { Presence } from "./presence";
import { Button } from "./ui";
import { Waiting } from "./Waiting";

/** Confirmation commune avant de quitter une saisie non enregistrée (registre `state/unsavedDrafts`, audit de
 *  persistance M4) : changement de vue, de dossier ou de langue. Même question que l'éditeur d'ordre de bataille ;
 *  « Revenir à la saisie » est le choix par défaut (focus, Entrée, Échap, clic sur le voile), « Enregistrer » quand
 *  l'éditeur peut enregistrer d'ici (le geste a lieu ensuite), « Abandonner » perd la saisie. */
export function UnsavedChangesHost() {
  const request = useLeaveRequest();
  return (
    <Presence show={request !== null}>
      {request && (
        <ConfirmDialog
          title={t("Abandonner les modifications ?")}
          confirmLabel={t("Abandonner")}
          cancelLabel={t("Revenir à la saisie")}
          onConfirm={() => !request.saving && unsavedDrafts.discard()}
          onCancel={() => {
            if (request.saving) return;
            unsavedDrafts.stay();
            // Saisie retenue depuis l'accueil (ouverture d'un autre dossier) : l'accueil s'efface sur l'éditeur.
            if (useUi.getState().welcome) useUi.getState().closeWelcome();
          }}
          extra={
            request.canSave ? (
              <Button variant="secondary" onClick={() => void unsavedDrafts.save()} disabled={request.saving}>
                <Check size={14} /> {request.saving ? <Waiting>{t("Enregistrement…")}</Waiting> : t("Enregistrer")}
              </Button>
            ) : undefined
          }
        >
          {request.labels.length === 1 ? (
            t("{what} : vos modifications ne sont pas enregistrées.", { what: request.labels[0] ?? "" })
          ) : (
            <>
              {t("Vos modifications ne sont pas enregistrées :")}
              <ul className="mt-1 list-disc pl-5">
                {request.labels.map((label, i) => (
                  <li key={i}>{label}</li>
                ))}
              </ul>
            </>
          )}
        </ConfirmDialog>
      )}
    </Presence>
  );
}
